export const ACCESS_TOKEN_MAX_AGE = 8 * 60 * 60; // 8 hours
export const REFRESH_TOKEN_MAX_AGE = 365 * 24 * 60 * 60; // 1 year
